import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import useBranchOptions from '../../hooks/useBranchOptions';
import { getUserByToken, loginToBranch } from '../../modules/Auth/_redux/authCrud';
import * as auth from '../../modules/Auth/_redux/authRedux';
import { useDispatch, useSelector } from 'react-redux';
import { USER_MODE } from '../../data/userModeConstants';
import {
  Autocomplete,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItem,
  ListItemButton,
  TextField
} from '@mui/material';
import { useIntl } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';

const BranchSelectorDialog = ({ open, onClickCloseDialog }) => {
  const intl = useIntl();
  const { branches } = useBranchOptions({
    includeHQ: false,
    showAllActive: true
  });
  const authToken = useSelector(state => state.auth.authToken);
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();

  const onSelectBranch = async branch => {
    await loginToBranch(authToken, branch._id);
    const {
      data: {
        data: { user }
      }
    } = await getUserByToken();

    window.location.reload();

    dispatch({ type: auth.actionTypes.UserLoaded, payload: { user } });
  };

  if (branches.length === 0) {
    return null;
  }

  const filteredBranches =
    user.mode !== USER_MODE.CUSTOMER
      ? branches.filter(
          branch => user?.assignedBranches?.length && user?.assignedBranches.some(b => b._id === branch._id)
        )
      : branches;

  const selectedBranch = filteredBranches.find(branch => branch._id === user.loggedInBranch?._id) || null;
  return (
    <>
      <Dialog
        open={open}
        maxWidth="sm"
        PaperProps={{
          sx: {
            minHeight: 200,
            width: '100%',
            minWidth: '25rem'
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>{intl.formatMessage({ id: 'branch' })}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClickCloseDialog}
          sx={theme => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Autocomplete
            value={selectedBranch}
            options={filteredBranches}
            // popupIcon={null}
            getOptionLabel={branch => branch.name}
            renderInput={params => <TextField {...params} fullWidth sx={{ paddingTop: 2 }} />}
            onChange={(event, newValue) => {
              if (newValue) onSelectBranch(newValue);
            }}
            renderOption={(props, branch) => (
              <ListItemButton {...props} key={branch._id} disabled={branch._id === user.loggedInBranch?._id}>
                {branch.name}
              </ListItemButton>
            )}
            disableClearable
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BranchSelectorDialog;
